import { TArticle } from '../models/common';

const useDocumentationArticles = () => {
  const filterDocumentationArticles = (articles: TArticle[], isDocumentationChannel: boolean) => {
    if (!isDocumentationChannel) return articles;
    return articles.filter(article => article.is_documentation);
  };

  return { filterDocumentationArticles };
};

export default useDocumentationArticles; 